import { render, staticRenderFns } from "./ProductTeaser.vue?vue&type=template&id=2368eac0&scoped=true&"
import script from "./ProductTeaser.vue?vue&type=script&lang=js&"
export * from "./ProductTeaser.vue?vue&type=script&lang=js&"
import style0 from "./ProductTeaser.vue?vue&type=style&index=0&id=2368eac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2368eac0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Media: require('/vercel/path0/components/Media.vue').default,Animation: require('/vercel/path0/components/Animation.vue').default,Btn: require('/vercel/path0/components/Btn.vue').default})
